// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
import { background } from '../../tokens/themeColors/background';
import { border } from '../../tokens/themeColors/border';
import { icon } from '../../tokens/themeColors/icon';
import { text } from '../../tokens/themeColors/text';
export var checkboxColors = function(mode) {
    var bg = background(mode);
    var bd = border(mode);
    var ic = icon(mode);
    var tx = text(mode);
    return {
        default: {
            border: bd.heavy,
            text: tx.primary
        },
        checked: {
            icon: ic.active
        },
        disabled: {
            background: bg.state.disabled2,
            checked: ic.disabled,
            text: tx.disabled3
        },
        error: {
            asterisk: bd.status.error
        },
        focus: {
            border: bd.actionBold
        },
        hover: {
            background: bg.state.hover0,
            border: bd.heaviest
        }
    };
};

//# sourceMappingURL=checkboxColors.js.map